export default "__VITE_ASSET__DVV$Evsl__"